/** Original server-directed navigation; it never submits a room transaction. */
export function navigateFromServer(path: string) {
  window.dispatchEvent(new CustomEvent("server-navigation", { detail: path }));
}
